import React from 'react';
import {connect} from 'react-redux';
import {changeDeviceSettings} from '../../../common/device/actions';

class Mouse extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        hideMouse: React.PropTypes.bool,
        changeDeviceSettings: React.PropTypes.func
    };

    render() {
        const {hideMouse, changeDeviceSettings, msg} = this.props;

        return (
            <div className="table-row">
              <div className="table-cell" style={{width: '55.55%'}}>
                <div className="boxBtn text-black text-left">
                    <div className="boxBtn-inner">
                      <div className="settings-name">
                        <span className="settings-name-name">{msg.settings.cursor.title}</span>
                        <span className="settings-name-info">{msg.settings.cursor.subtitle}</span>
                      </div>
                    </div>
                </div>
              </div>
              <div className="table-cell" style={{width: '44.44%'}}>
                <div className="switch">
                    <div className={`switch-option text-l ${hideMouse ? 'active' : ''} color-greenLight`}
                         onClick={() => changeDeviceSettings('hideMouse', true)}>
                        <div className="switch-inner">
                            <span>{msg.settings.on}</span>
                        </div>
                    </div>
                    <div className={`switch-option text-l ${hideMouse ? '' : 'active'} color-red`}
                         onClick={() => changeDeviceSettings('hideMouse' ,false)}>
                        <div className="switch-inner">
                            <span>{msg.settings.off}</span>
                        </div>
                    </div>
                </div>
              </div>
            </div>
        );

    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    hideMouse: state.device.hideMouse
}), {changeDeviceSettings})(Mouse);



// WEBPACK FOOTER //
// ./src/browser/menu/settings/Mouse.js